/**
 * Регистрация служебного потока — того, что делает карту приложением.
 * Сам поток лежит в `public/sw.js`.
 *
 * ПОЧЕМУ НЕ В РЕЖИМЕ РАЗРАБОТКИ. Поток кеширует оболочку и живёт дольше вкладки:
 * на `pnpm dev` это значит правку, которой не видно, и полчаса поисков причины.
 *
 * ПОЧЕМУ НЕ В ПРИЛОЖЕНИИ ДЛЯ ТЕЛЕФОНА. Там оболочка уже нативная: Android-сборка
 * открывает те же файлы с устройства, и второй слой кеша ей не нужен.
 *
 * ОШИБКА РЕГИСТРАЦИИ НИЧЕГО НЕ ЛОМАЕТ. Приватный режим, отключённые куки, старый
 * браузер — карта работает и без установки, просто остаётся страницей.
 */

export function registerServiceWorker(): void {
  if (import.meta.env.DEV || import.meta.env.VITE_NATIVE === 'true') {
    return
  }

  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return
  }

  // После загрузки страницы, а не во время: регистрация соревновалась бы
  // за сеть с тем, ради чего гость открыл карту, — с баллами и кодом.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Молча: установка — приятное дополнение, а не условие работы.
    })
  })
}
